export const Constants = {
  BetStopURL: 'https://www.betstop.gov.au/',
  GamblingHelpOnlineURL: 'https://gamblinghelponline.org.au/',
  GamblingHelpPhoneNumber: '1800 858 858',
  ResponsibleWageringURL: 'https://www.tabtouch.mobi/Content/landing/responsible-wagering/',
  TermsAndConditions: 'https://www.rwwa.com.au/terms---conditions',
} as const
